<template>
  <div class="flex w-full">
    <div class="w-1/3">
      <div class="w-full mb-3 h-3px bg-secondary" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-10 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" v-bind:svg-inline="''" v-bind:class="'w-4.25 h-4.25'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8 0a8 8 0 00-5.65 2.33A8.19 8.19 0 00.63 4.88a8 8 0 000 6.22 8.11 8.11 0 004.27 4.27A7.68 7.68 0 008 16a7.77 7.77 0 003.12-.63 8.19 8.19 0 002.55-1.72 8 8 0 001.71-2.55A7.84 7.84 0 0016 8a7.76 7.76 0 00-.62-3.12A8 8 0 008 0z" fill="#333"/><path d="M4.77 7.69l-1.39 1.7 4 3.23L12.48 6l-1.73-1.38L7 9.49l-2.23-1.8" fill="#fff"/></svg>
          </div>
          <div
            v-if="activeStep <= 1"
            class="w-4.25 h-4.25 rounded-full text-xxs flex items-center justify-center leading-none font-bold"
            :class="[ activeStep === 1 ? 'bg-secondary' : 'bg-gray-350 text-white' ]"
          >
            1
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold': activeStep === 1, 'text-gray-900': activeStep > 1 }">{{ step1 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 2 ? 'bg-secondary': 'bg-gray-350']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-10 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div v-if="activeStep > 2">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" v-bind:svg-inline="''" v-bind:class="'w-4.25 h-4.25 xl:w-5 xl:h-5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8 0a8 8 0 00-5.65 2.33A8.19 8.19 0 00.63 4.88a8 8 0 000 6.22 8.11 8.11 0 004.27 4.27A7.68 7.68 0 008 16a7.77 7.77 0 003.12-.63 8.19 8.19 0 002.55-1.72 8 8 0 001.71-2.55A7.84 7.84 0 0016 8a7.76 7.76 0 00-.62-3.12A8 8 0 008 0z" fill="#333"/><path d="M4.77 7.69l-1.39 1.7 4 3.23L12.48 6l-1.73-1.38L7 9.49l-2.23-1.8" fill="#fff"/></svg>
          </div>
          <div
            v-if="activeStep <= 2"
            class="w-4.25 h-4.25 rounded-full text-xxs flex items-center justify-center leading-none font-bold"
            :class="[ activeStep === 2 ? 'bg-secondary' : 'bg-gray-350 text-white' ]"
          >
            2
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold': activeStep === 2, 'text-gray-900': activeStep > 2, 'text-gray-350': activeStep < 2 }">{{ step2 }}</span>
      </div>
    </div>
    <div class="w-1/3">
      <div :class="['w-full h-3px mb-3', activeStep >= 3 ? 'bg-secondary': 'bg-gray-350']" />
      <div class="flex flex-col items-center leading-none text-center text-xxs xl:flex-row xl:text-left xl:pl-10 xl:text-sm">
        <div class="flex-shrink-0 mb-2 xl:mb-0 xl:mr-2">
          <div
            v-if="activeStep <= 3"
            class="w-4.25 h-4.25 rounded-full text-xxs flex items-center justify-center leading-none font-bold"
            :class="[ activeStep === 3 ? 'bg-secondary' : 'bg-gray-350 text-white' ]"
          >
            3
          </div>
        </div>
        <span class="px-1" :class="{ 'font-bold': activeStep === 3, 'text-gray-900': activeStep > 3, 'text-gray-350': activeStep < 3 }">{{ step3 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherNavigation from '~components/navigation/step-navigation'

export default VoucherNavigation.extend()
</script>
